// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"037a32fe","75":"aba242df","779":"e5b70838","787":"c5366f46"}[chunkId] + ".chunk.js";
};